// extracted by mini-css-extract-plugin
module.exports = {"zohoForm":"zohoConfig_zohoForm__1-ees","wrapper":"zohoConfig_wrapper__2-pbe","helpText":"zohoConfig_helpText__2EO1c"};